import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/NotFound'
import PrivacyPlicy from '@/components/PrivacyPlicy'
import PrivacyPlicyMakeTransparent from '@/components/PrivacyPlicyMakeTransparent'
import PrivacyPlicyFileFormatChanger from '@/components/PrivacyPlicyFileFormatChanger'
import PrivacyPlicyDividendCalculation from '@/components/PrivacyPlicyDividendCalculation'

Vue.use(Router)

export default new Router({
  mode: 'history', // URLに#がつかなくなる
  routes: [
    {
      // ルートに来たアクセスは漫画アプリのページへリダイレクト
      path: '/',
      redirect: '/privacypolicy/makecartoon'
    },
    // 初期は/privacypolicyで漫画作成アプリのプライバシーポリシーを表示するサイトだったのでこの時もリダイレクト。(ブックマークしている人などがいるといけないので。ないとは思うが…)
    {
      path: '/privacypolicy',
      redirect: '/privacypolicy/makecartoon'
    },
    {
      path: '/privacypolicy/makecartoon',
      name: 'PrivacyPlicy',
      component: PrivacyPlicy,
      // 画面の細部を決めるためのデータ
      meta: {
        appTitle: '漫画作成アプリ',
        appBarColor: 'blue lighten-5',
        textColorClass: 'blue--text text--darken-3' // テキストカラーは明暗を調整には、色の指定と明暗の指定で二つ必要。
      }
    },
    {
      path: '/privacypolicy/maketransparent',
      name: 'PrivacyPlicyMakeTransparent',
      component: PrivacyPlicyMakeTransparent,
      // 画面の細部を決めるためのデータ
      meta: {
        appTitle: '背景透過アプリ',
        appBarColor: 'purple accent-1',
        textColorClass: 'purple--text text--darken-3' // テキストカラーは明暗を調整には、色の指定と明暗の指定で二つ必要。
      }
    },
    {
      path: '/privacypolicy/fileformatchanger',
      name: 'PrivacyPlicyFileFormatChanger',
      component: PrivacyPlicyFileFormatChanger,
      // 画面の細部を決めるためのデータ
      meta: {
        appTitle: '画像拡張子変換アプリ',
        appBarColor: 'green accent-1',
        textColorClass: 'black--text text--darken-3' // テキストカラーは明暗を調整には、色の指定と明暗の指定で二つ必要。
      }
    },
    {
      path: '/privacypolicy/dividendcalculation',
      name: 'PrivacyPlicyDividendCalculation',
      component: PrivacyPlicyDividendCalculation,
      // 画面の細部を決めるためのデータ
      meta: {
        appTitle: '配当利回り計算アプリ',
        appBarColor: 'lime lighten-4',
        textColorClass: 'black--text text--darken-3' // テキストカラーは明暗を調整には、色の指定と明暗の指定で二つ必要。
      }
    },

    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        appTitle: 'エラー',
        appBarColor: 'pink lighten-4',
        textColorClass: 'pink--text text--darken-3' // テキストカラーは明暗を調整には、色の指定と明暗の指定で二つ必要。
      }
    }

  ]
})
